window.jQuery = window.$ = require('jquery');
var Multiselect = require('bootstrap-multiselect/dist/js/bootstrap-multiselect');
var _without = require('lodash/array/without');

require('style!css!bootstrap-multiselect/dist/css/bootstrap-multiselect.css');

(function(window, document, $) {

  $(document).ready(function() {

    if ($('.course-list')) {
      // Filter the course list given an array of selected IDs
      function filterCourses(courseTypeIds, instant) {
        // Start the "shown" count for striping
        var shownCount = 0;
        // If instant is true, set speed to 0, otherwise set it to 400
        var speed = instant ? 0 : 400;

        // if the courseTypeIds array has any elements
        if (courseTypeIds.length) {
          $allCourses.map(function(index, element) {
            var $course = $(this);
            var course_type_id = Number($course.data('course-type'));
            // if this course's type Id is in the array
            if (courseTypeIds.indexOf(course_type_id) != -1) {
              $course.slideDown(speed, function() {
                $course.removeClass('hidden-course');
              });
              shownCount++;
              // if this is an odd course
              if (shownCount % 2 != 0) {
                $course.addClass('odd');
              } else { // if it's an even course
                $course.removeClass('odd');
              }
            } else { // If it's not in the array
              $course.slideUp(speed, function() {
                $course.addClass('hidden-course');
              });
            }
          });
        } else { // If the courseTypeIds array doesn't have any elements
          $allCourses.map(function(index, element) {
            var $course = $(this);
            var speed = instant ? 0 : 400;
            $course.slideDown(speed, function() {
              $course.removeClass('hidden-course');
            });
            shownCount++;
            // if this is an odd course
            if (shownCount % 2 != 0) {
              $course.addClass('odd');
            } else { // if it's an even course
              $course.removeClass('odd');
            }
          });
        }
        if (shownCount == 0) {
          $('.course-list__no-results').slideDown(speed);
        } else {
          $('.course-list__no-results').slideUp(speed);
        }
      }

      // Collect all course elements from course list
      var $allCourses = $('.course-list__item');

      // Grab course type URI segment and initialize selectedCourseTypes
      var pathArray = window.location.pathname.split( '/' );
      var secondLevelLocation = pathArray[2];
      var initialCourseTypeIds = {
        "wilderness-first-aid": [11],
        "semester-in-wilderness-medicine": [22],
        "wilderness-first-responder": [13],
        "wilderness-emt": [9],
        "cpr": [26, 1, 21],
        "wilderness-medicine-essentials": [4],
        "first-aid": [31, 1]
      };
      var selectedCourseTypes = initialCourseTypeIds[ secondLevelLocation ];
      if (Array.isArray(selectedCourseTypes)) {
        var selectedCourseTypes = initialCourseTypeIds[secondLevelLocation];
      } else {
        var selectedCourseTypes = [];
      }

      // Initial filtering/striping
      filterCourses(selectedCourseTypes, true);

      // Initialize jQuery/Bootstrap Multiselect
      $('#course_types').multiselect({
        buttonWidth: '100%',
        maxHeight: 300,
        enableCaseInsensitiveFiltering: true,
        onChange: function(element, checked) {
          var value = $(element).val();
          if (checked === true) {
            selectedCourseTypes.push(Number(value));
          }
          else if (checked === false) {
            selectedCourseTypes = _without(selectedCourseTypes, Number(value));
          }
          filterCourses(selectedCourseTypes);
        },
        buttonText: function(options, select) {
          if (options.length === 0) {
              return 'Filter Course Types';
          } else if (options.length > 3) {
              return options.length + ' Course Types Selected';
          } else {
            var labels = [];
            options.each(function() {
              if ($(this).attr('label') !== undefined) {
                labels.push($(this).attr('label'));
              } else {
                labels.push($(this).html());
              }
            });
            return labels.join(', ') + '';
          }
        }
      });
    }

  });

}(window, window.document, window.jQuery)); // Fully reference jQuery after this point.



/** WEBPACK FOOTER **
 ** ./js/course-listing.js
 **/